<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2023-07-06 13:48:00
 * @LastEditTime: 2026-07-06 13:55:18
 * @LastEditors: hexy 913752270@qq.com
 * @Description  : 工程收款
 * @FilePath: \ICPSxin\src\views\platform\ICPS\internetSales\projectPayment.vue
-->
<template>
  <div class="pages_content table">
    <el-container>
      <el-header>
        <breaDcrumb />
      </el-header>
      <div class="header_right" @click="showCardNav = !showCardNav">
        <div class="title">搜索</div>
        <div>
          <div :class="{ arrowTransform: !showCardNav, arrowTransformReturn: showCardNav }">
            <i style="margin-right: 5px" class="el-icon-arrow-down"></i>
          </div>
        </div>
      </div>
      <div v-show="showCardNav" class="hr"></div>
      <el-collapse-transition>
        <div v-show="showCardNav">
          <div class="search">
            <span style="display: inline-block; margin-right: 24px; margin-bottom: 10px">
              <span style="margin-right: 12px; display: inline-block; width: 70px; text-align: right">是否认领：</span>
              <el-select v-model="tableParam.claimStatus" style="width: 200px" clearable placeholder="请选择">
                <el-option v-for="(item, index) in claimList" :key="index" :label="item.name"
                  :value="item.id"></el-option>
              </el-select>
            </span>
            <span style="display: inline-block; margin-right: 24px; margin-bottom: 10px">
              <span style="margin-right: 12px; display: inline-block; width: 70px; text-align: right">日期 ：</span>
              <el-date-picker v-model="startTimDateEndTimDate" type="daterange" unlink-panels value-format="yyyy-MM-dd"
                start-placeholder="开始时间" end-placeholder="结束时间"
                @change="(tableParam.collectMoneyDataStart = startTimDateEndTimDate ? startTimDateEndTimDate[0] : ''), (tableParam.collectMoneyDataEnd = startTimDateEndTimDate ? startTimDateEndTimDate[1] : '')"></el-date-picker>
            </span>
            <span style="display: inline-block; margin-right: 24px; margin-bottom: 10px">
              <span style="margin-right: 12px; display: inline-block; width: 70px; text-align: right">工程名称:</span>
              <el-input v-model="tableParam.enginnerrName" style="width: 200px" clearable placeholder="请输入" />
            </span>
            <span style="display: inline-block; margin-right: 24px; margin-bottom: 10px">
              <span style="margin-right: 12px; display: inline-block; width: 70px; text-align: right">票号：</span>
              <el-input v-model="tableParam.tiketNumber" style="width: 200px" clearable placeholder="请输入" />
            </span>
            <span style="display: inline-block; margin-right: 24px; margin-bottom: 10px">
              <span style="margin-right: 12px; display: inline-block; width: 110px; text-align: right">合同签订主体：</span>
              <el-input v-model="tableParam.collaborationUnit" style="width: 200px" clearable placeholder="请输入" />
            </span>
            <span style="display: inline-block; margin-right: 24px; margin-bottom: 10px">
              <span style="margin-right: 12px; display: inline-block; width: 70px; text-align: right">销售员：</span>
              <el-input v-model="tableParam.saller" style="width: 200px" clearable placeholder="请输入" />
            </span>
            <span style="display: inline-block; margin-right: 24px; margin-bottom: 10px">
              <span style="margin-right: 12px; display: inline-block; width: 70px; text-align: right">收款金额：</span>
              <el-input v-model="tableParam.collectMoneyStart" style="width: 200px" clearable
                placeholder="请输入" />至<el-input v-model="tableParam.collectMoneyEnd" style="width: 200px" clearable
                placeholder="请输入" />
            </span>
            <span style="display: inline-block; margin-right: 24px; margin-bottom: 10px">
              <span style="margin-right: 12px; display: inline-block; width: 70px; text-align: right">收款形式：</span>
              <el-select v-model="tableParam.collectMoneyMethodId" style="width: 300px" placeholder="请选择" clearable
                @change="getCollectMoneyMethod(tableParam.collectMoneyMethodId)">
                <el-option v-for="(item, index) in shoukuanList" :key="index" :label="item.itemName"
                  :value="item.id"></el-option>
              </el-select>
            </span>
            <span style="display: inline-block; margin-right: 24px; margin-bottom: 10px">
              <span style="margin-right: 12px; display: inline-block; width: 150px; text-align: right">收款行及金融工具：</span>
              <el-select v-model="tableParam.collectMoneyBankId" filterable style="width: 300px" placeholder="请选择"
                clearable>
                <el-option v-for="(item, index) in shoukuanandmonList" :key="index" :label="item.itemName"
                  :value="item.id"></el-option>
              </el-select>
            </span>
            <span style="display: inline-block; margin-right: 24px; margin-bottom: 10px">
              <span style="margin-right: 12px; display: inline-block; width: 70px; text-align: right">财务编码：</span>
              <el-input v-model="tableParam.financialCode" style="width: 200px" clearable placeholder="请输入" />
            </span>
            <span style="display: inline-block; margin-bottom: 10px">
              <el-button icon="el-icon-search" size="medium" class="bottom_all"
                @click="(tableParam.page = 1), gettableDataex()">查 询</el-button>
              <el-button size="medium" class="bottom_all_two" style="margin-left: 12px" @click="init()">重 置</el-button>
            </span>
          </div>
        </div>
      </el-collapse-transition>
      <div class="hr"></div>
      <div class="card_nav">
        <div style="display: flex; align-items: center">
          <el-button v-if="ButtonList.findIndex(res => res.buttonValue == 'TIANJIA') !== -1" size="small"
            class="bottom_all" style="margin-left: 0" @click="addcard"> 添加 </el-button>
          <el-button v-if="ButtonList.findIndex(res => res.buttonValue == 'FUKUANDANWEI') !== -1" size="small"
            class="bottom_all" style="margin-left: 10px" @click="costMoneyInit"> 付款单位管理 </el-button>
          <el-button v-if="ButtonList.findIndex(res => res.buttonValue == 'SKQR') !== -1" size="small" class="bottom_all"
            style="margin-left: 10px" @click="receiveConfirm"> 收款确认 </el-button>

          <!-- <el-button
            v-if="ButtonList.findIndex(res => res.buttonValue == 'XIAOSHOUQUEREN') !== -1" size="small" class="bottom_all"
            style="margin-left: 10px" :loading="loadingSaller" @click="
              loadingSaller = true;
            sallerSure();
            ">
            销售确认
          </el-button> -->
          <el-button size="small" class="bottom_one" @click="complete"> 完结 </el-button>
          <el-button v-if="ButtonList.findIndex(res => res.buttonValue == 'SHANCHU') !== -1" size="small"
            class="bottom_two" @click="delHandler"> 删除 </el-button>
          <el-button v-if="ButtonList.findIndex(res => res.buttonValue == 'DONGJIE') !== -1" class="bottom_one"
            @click="changeFreeze(1, '冻结')"> 冻结 </el-button>
          <el-button v-if="ButtonList.findIndex(res => res.buttonValue == 'JIEDONG') !== -1" class="bottom_one"
            @click="changeFreeze(0, '解冻')"> 解冻 </el-button>
          <el-button class="bottom_one" @click="handleCopyClick"> 复制 </el-button>
          <div style="margin-left: 10px; color: red; font-weight: bold"><span style="">已认领合计金额：</span>{{ tableData[0] ?
            (tableData[0].totalMoney ? numFormat(tableData[0].totalMoney) : 0) : 0 }} 元</div>
        </div>
        <div>
          <el-button size="medium" class="bottom_all" style="margin-left: 12px" @click="load()">导 出</el-button>
        </div>
      </div>
      <el-main style="display: flex">
        <div>
          <!-- <div class="card scroll"> -->
          <div class="card overheight">
            <!-- { background: '#f3f6f9' }  :row-class-name="tableRowClassName"-->
            <div v-loading="tableLoading" class="card_info" :style="style">
              <el-table ref="table" :header-cell-style="setTitle" :cell-style="{ borderRight: 'none' }" border stripe
                style="width: 100%" :data="tableData" tooltip-effect="dark" :height="screenHeight - 560"
                :span-method="objectSpanMethod" @selection-change="handleSelectionChange">
                <el-table-column align="center" type="selection"></el-table-column>
                <template v-for="(item, index2) in table">
                  <el-table-column v-if="item.status" :key="index2" :label="item.label" align="center"
                    :min-width="item.width" :fixed="item.label == '操作' ? 'right' : false">
                    <template slot-scope="scope">
                      <span v-if="item.label == '状态'">
                        <span v-if="scope.row.dataStatus == 0" style="color: #969799">未开票</span>
                        <span v-if="scope.row.dataStatus == 1" style="color: #00a754">已开票</span>
                      </span>
                      <span v-if="item.label == '收款状态'">
                        <span v-if="scope.row.sureStatus == 0">未确认</span>
                        <span v-if="scope.row.sureStatus == 1" style="color: red">已确认</span>
                      </span>
                      <span v-else-if="item.label == '集团内'">
                        <span v-if="scope.row.whetherGroup == 0" style="color: #969799">否</span>
                        <span v-else-if="scope.row.whetherGroup == 1" style="color: #00a754">是</span>
                      </span>
                      <span v-else-if="item.label == '收款（元'">
                        <span>{{ numFormat(scope.row.collectMoney || 0) }}</span>
                      </span>
                      <span v-else-if="item.label == '已认领（元）'">
                        <span>{{ numFormat(scope.row.claimMoney || 0) }}</span>
                      </span>
                      <span v-else-if="item.label == '其他金额'">
                        <span>{{ numFormat(scope.row.otherMoney || 0) }}</span>
                      </span>
                      <span v-else-if="item.label == '票据状态'">
                        <span v-if="scope.row.billStatus == 0" style="color: #969799">普通票据</span>
                        <span v-else-if="scope.row.billStatus == 1" style="color: #00a754">已贴现</span>
                        <span v-else-if="scope.row.billStatus == 2" style="color: #2ac5ec">已兑付</span>
                      </span>
                      <span v-else-if="item.label == '流程'">
                        <span v-if="scope.row.flowPath == 0" style="color: #969799">流程未走完</span>
                        <span v-if="scope.row.flowPath == 1" style="color: #00a754">流程已走完</span>
                      </span>
                      <span v-else-if="item.label == '是否认领'">
                        <span style="color: #969799">{{ ["流水待认领", "流水未认领完", "流水已认领，流程中", "流水已认领",
                          "已完结"][scope.row.claimStatus] }}</span>
                      </span>
                      <div v-else-if="item.label == '操作'">
                        <span v-if="scope.row.freeze != 1">
                          <el-button v-if="ButtonList.findIndex(res => res.buttonValue == 'XIUGAI') !== -1"
                            class="bottom_one" size="mini"
                            :disabled="ButtonList.findIndex(res => res.buttonValue == 'YQRXG') == -1 && scope.row.sureStatus == 1"
                            @click="lookcard(scope.row)"> 修改 </el-button>
                          <el-button v-if="ButtonList.findIndex(res => res.buttonValue == 'RENLING') !== -1"
                            class="bottom_one" size="mini" @click="addOtherCard(scope.row)"> 认领 </el-button>
                        </span>
                      </div>
                      <span v-else>{{ scope.row[item.prop] }}</span>
                    </template>
                  </el-table-column>
                </template>
              </el-table>
            </div>
          </div>
        </div>
      </el-main>
      <div class="card_bottom">
        <div class="card_bottom_left">
          <div class="top_page_totle">总共{{ total }}条</div>
          <el-pagination :current-page.sync="tableParam.page" :page-size="tableParam.pageSize"
            :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]" layout="prev,pager,sizes,next,jumper" :total="total"
            @size-change="sizeChange" @current-change="gettableDataex()"></el-pagination>
        </div>
        <div>
          <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two"
            @click="gettableDataex">刷新</el-button>
        </div>
      </div>
    </el-container>
    <!-- <diaLog1 :dialog="dialog1" :low="low" @reset="reset" @submit="submit"></diaLog1> -->
    <el-dialog :title="titleName" :visible.sync="dialog" width="1000px" :close-on-click-modal="false">
      <div>
        <el-form ref="formDate" :rules="rules" :model="formDate" :inline="true" label-width="160px">
          <el-form-item label="日期：" prop="collectMoneyData">
            <el-date-picker v-model="formDate.collectMoneyData" type="date" style="width: 300px" value-format="yyyy-MM-dd"
              placeholder="选择日期" @change="setMonth"> </el-date-picker>
          </el-form-item>
          <el-form-item label="月份：" prop="collectMoneyMouth">
            <el-date-picker v-model="formDate.collectMoneyMouth" disabled type="month" style="width: 300px"
              value-format="yyyy-MM" placeholder="选择月"> </el-date-picker>
          </el-form-item>
          <el-form-item label="收款形式：" prop="collectMoneyMethodId">
            <el-select ref="shoukuanList" v-model="formDate.collectMoneyMethodId" style="width: 300px" placeholder="请选择"
              @change="
                changestatus(formDate.collectMoneyMethodId),
                $nextTick(() => {
                  formDate.collectMoneyMethod = $refs.shoukuanList.selectedLabel;
                })
                ">
              <el-option v-for="(item, index) in shoukuanList" :key="index" :label="item.itemName"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="收款行及金融工具：" prop="collectMoneyBankId"
            :rules="[{ required: isMust2, message: '请选择收款行及金融工具', trigger: 'change' }]">
            <el-select ref="shoukuanandmonList" v-model="formDate.collectMoneyBankId" filterable style="width: 300px"
              placeholder="请选择" @change="
                $nextTick(() => {
                  formDate.collectMoneyBank = $refs.shoukuanandmonList.selectedLabel;
                })
                ">
              <el-option v-for="(item, index) in shoukuanandmonList" :key="index" :label="item.itemName"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="收款：" prop="collectMoney">
            <el-input v-model="formDate.collectMoney" style="width: 300px" clearable placeholder="请输入" maxlength="12"
              @change="collectMoneyChange">
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
          <el-form-item label="付款单位：" prop="payUnitId">
            <el-select ref="payUnit" v-model="formDate.payUnitId" style="width: 300px" filterable placeholder="请选择"
              @change="
                changePayUnit();
              $nextTick(() => {
                formDate.payUnit = $refs.payUnit.selectedLabel;
              });
              ">
              <el-option v-for="(item, index) in payerUnitNoPage" :key="index" :label="item.payerUntiName"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="主体：" prop="collaborativeAgentId">
            <el-select ref="collaborativeAgent" v-model="formDate.collaborativeAgentId" style="width: 300px" filterable
              placeholder="请选择" @change="changeCollaborat()">
              <el-option v-for="(item, index) in mainListBodys" :key="index" :label="item.itemName"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="票据类型：" prop="billTypeId"
            :rules="[{ required: isMust, message: '请选择票据类型', trigger: 'change' }]">
            <el-select ref="billType" v-model="formDate.billTypeId" filterable style="width: 300px" placeholder="请选择"
              @change="
                $nextTick(() => {
                  formDate.billType = $refs.billType.selectedLabel;
                })
                ">
              <el-option v-for="(item, index) in piaojuList" :key="index" :label="item.itemName"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="票号：" prop="tiketNumber" :rules="[{ required: isMust, message: '请输入票号', trigger: 'blur' }]">
            <el-input v-model="formDate.tiketNumber" style="width: 300px" clearable placeholder="请输入"
              @blur="formDate.tiketNumber = $regExp.enableSpace(formDate.tiketNumber)" />
          </el-form-item>
          <el-form-item label="承兑人名称：" prop="acceptor"
            :rules="[{ required: isMust, message: '请输入承兑人名称：', trigger: 'blur' }]">
            <el-input v-model="formDate.acceptor" style="width: 300px" clearable placeholder="请输入" />
          </el-form-item>
          <el-form-item label="出票人户名：" prop="drawerAccount"
            :rules="[{ required: isMust, message: '请输入出票人户名', trigger: 'blur' }]">
            <el-input v-model="formDate.drawerAccount" style="width: 300px" clearable placeholder="请输入" />
          </el-form-item>
          <el-form-item label="收款人户名：" prop="payeeAccount"
            :rules="[{ required: isMust, message: '请输入收款人户名', trigger: 'change' }]">
            <!-- <el-input v-model="formDate.payeeAccountId" style="width: 300px" clearable placeholder="请输入" /> -->
            <el-select ref="collaborativeAgent" v-model="formDate.payeeAccount" style="width: 300px" filterable
              allow-create placeholder="请选择" @change="changePayeeAccount()">
              <el-option v-for="(item, index) in mainList" :key="index" :label="item.name" :value="item.name"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="授信银行：" prop="creditBank"
            :rules="[{ required: isMust, message: '请输入授信银行', trigger: 'change' }]">
            <el-input v-model="formDate.creditBank" style="width: 300px" clearable placeholder="请输入" />
          </el-form-item>
          <el-form-item label="背书人：" prop="endorser"
            :rules="[{ required: isMust, message: '请输入背书人', trigger: 'change' }]">
            <el-input v-model="formDate.endorser" style="width: 300px" clearable placeholder="请输入" />
          </el-form-item>
          <el-form-item label="出票日期：" prop="issueDate"
            :rules="[{ required: isMust, message: '请选择出票日期', trigger: 'change' }]">
            <el-date-picker v-model="formDate.issueDate" type="date" style="width: 300px" placeholder="选择日期"
              value-format="yyyy-MM-dd"> </el-date-picker>
          </el-form-item>
          <el-form-item label="到期日期：" prop="dueDate"
            :rules="[{ required: isMust, message: '请选择到期日期', trigger: 'change' }]">
            <el-date-picker v-model="formDate.dueDate" type="date" style="width: 300px" placeholder="选择日期"
              value-format="yyyy-MM-dd"> </el-date-picker>
          </el-form-item>
          <el-form-item label="合同、流程：" prop="contractProcess">
            <el-select ref="contractProcess" v-model="formDate.contractProcess" filterable allow-create
              default-first-option style="width: 300px" placeholder="请选择" @change="structuralPartsCheckFun()">
              <el-option v-for="(item, index) in contractProcessList" :key="index" :label="item"
                :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="追索转让：" prop="recourseTransferId"
            :rules="[{ required: isMust3, message: '请选择追索转让', trigger: 'change' }]">
            <el-select ref="recourseTransfer" v-model="formDate.recourseTransferId" style="width: 300px" placeholder="请选择"
              @change="
                $nextTick(() => {
                  formDate.recourseTransfer = $refs.recourseTransfer.selectedLabel;
                })
                ">
              <el-option v-for="(item, index) in recourseTransferList" :key="index" :label="item.name"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="收取方式：">
            <el-select ref="collectionMethod" v-model="formDate.collectionMethodId" style="width: 300px" placeholder="请选择"
              @change="
                $nextTick(() => {
                  formDate.collectionMethod = $refs.collectionMethod.selectedLabel;
                })
                ">
              <el-option v-for="(item, index) in collectionMethodList" :key="index" :label="item.name"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否可融资：">
            <el-input v-model="formDate.remarkOne" style="width: 300px" clearable placeholder="请输入" />
          </el-form-item>
          <el-form-item label="备注2：">
            <el-input v-model="formDate.remarkTwo" style="width: 300px" clearable placeholder="请输入" />
          </el-form-item>
          <el-form-item label="备注3：">
            <el-input v-model="formDate.remarkThree" style="width: 300px" clearable placeholder="请输入" />
          </el-form-item>
          <el-form-item label="备注4：">
            <el-input v-model="formDate.remarkFour" style="width: 300px" clearable placeholder="请输入" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialog = false">取 消</el-button>
        <el-button type="primary" @click="addcardSure('formDate')">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="付款单位管理" :visible.sync="dialog1" width="1000px" :close-on-click-modal="false">
      <div>
        <el-form ref="reffromDate" :rules="rules" :inline="true" :model="low" label-width="140px">
          <el-form-item label="合同单位:">
            <el-input v-model="payerUnitParams.payerUntiName" style="width: 300px" clearable placeholder="请输入" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="
              payerUnitParams.page = 1;
            getpayerUnitManage();
            ">查 询</el-button>
            <el-button type="primary" @click="dialog2 = true">添 加</el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
        style="width: 100%" :data="tablepayerUnit" tooltip-effect="dark">
        <el-table-column label="合同单位" align="center" width="auto">
          <template slot-scope="scope">
            <span>{{ scope.row.payerUntiName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="集团内" align="center" width="auto">
          <template slot-scope="scope">
            <span v-if="scope.row.whetherGroup == 0" style="color: #969799">否</span>
            <span v-else-if="scope.row.whetherGroup == 1" style="color: #00a754">是</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="auto">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="
              dialog2 = true;
            addPayerUnit = scope.row;
            ">
              <i class="icon iconfont" style="font-size: 12px"></i>
              修改
            </el-button>
            <el-button size="mini" class="bottom_two" @click="delPayerUnit(scope.row)">
              <i class="icon iconfont" style="font-size: 12px"></i>
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="card_bottom">
        <div class="card_bottom_left">
          <div class="top_page_totle">总共{{ totalpayerUnit }}条</div>
          <el-pagination :current-page.sync="payerUnitParams.page" layout="prev,pager,sizes,next,jumper"
            :total="totalpayerUnit" @current-change="getpayerUnitManage()"></el-pagination>
        </div>
        <div>
          <!-- <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two"
                        @click="gettableDataex">刷新</el-button> -->
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialog1 = false">关 闭</el-button>
        <!-- <el-button type="primary" @click="dialog1 = false">确 定</el-button> -->
      </span>
    </el-dialog>

    <!-- 添加付款单位 -->
    <el-dialog title="添加/修改" :visible.sync="dialog2" width="500px" :close-on-click-modal="false">
      <div>
        <el-form ref="reffromDate" :rules="rules" :inline="true" :model="addPayerUnit" label-width="140px">
          <el-form-item label="合同单位:">
            <el-input v-model="addPayerUnit.payerUntiName" style="width: 300px" clearable placeholder="请输入" />
          </el-form-item>
          <el-form-item label="集团内：">
            <el-radio v-model="addPayerUnit.whetherGroup" :label="1">是</el-radio>
            <el-radio v-model="addPayerUnit.whetherGroup" :label="0">否</el-radio>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="
          dialog2 = false;
        initaddPayer();
        ">关 闭</el-button>
        <el-button type="primary" @click="addPayerUnitSure">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 销售确认 -->
    <el-dialog title="销售确认" :visible.sync="dialog3" width="500px" :close-on-click-modal="false">
      <div>请确认需要接收收款确认短信的人员:</div>
      <div style="margin-top: 20px">
        <el-form ref="reffromDate" :rules="rules" :inline="true" :model="low" label-width="80px">
          <el-form-item label="发送对象:">
            <!-- <el-cascader
              ref="cascader"
              v-model="userList"
              :options="treeArry"
              :show-all-levels="false"
              :props="{ value: 'id', label: 'name', children: 'children', multiple: true }"
              filterable
              @change="userChooseChange"
            ></el-cascader> -->
            <el-select v-model="userList" multiple filterable placeholder="请输入关键词" remote reserve-keyword>
              <el-option v-for="item in userData" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="addsallerList">添加</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="boxSaller">
        <div v-for="(item, index) in sallerList" :key="index" class="sallerItem">
          <div>{{ item.saller }} <i class="el-icon-close" style="cursor: pointer" @click="delItem(index)"></i></div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialog3 = false">关 闭</el-button>
        <el-button type="primary" @click="sendSrueSaller">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 认领 -->
    <el-dialog title="认领" :visible.sync="dialog4" width="1200px" :close-on-click-modal="false">
      <div>
        <el-form ref="reffromDate" :rules="rules" :inline="true" :model="formDate" label-width="140px">
          <el-form-item label="收款（元）:">
            <el-input v-model="formDate.collectMoney" style="width: 300px" disabled placeholder="请输入" />
          </el-form-item>
          <el-form-item label="已认领（元）:">
            <el-input v-model="formDate.claimMoney" style="width: 300px" disabled placeholder="请输入" />
          </el-form-item>
          <el-form-item label="付款单位:">
            <el-input v-model="formDate.payUnit" style="width: 300px" disabled placeholder="请输入" />
          </el-form-item>
          <el-form-item label="收款单位">
            <el-input v-model="formDate.collaborativeAgent" style="width: 300px" disabled placeholder="请输入" />
          </el-form-item>
          <div>
            <el-form-item>
              <el-button type="primary" @click="addCollectClaim">添 加</el-button>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
        style="width: 100%" :data="collectClaimList" tooltip-effect="dark">
        <el-table-column label="工程名称" align="center" width="300">
          <template slot-scope="scope">
            <el-select v-model="scope.row.engineeringId" style="width: 280px" filterable placeholder="请选择"
              @change="changstatus(scope.$index, scope.row)">
              <el-option v-for="(item, index) in engineeringNameList" :key="index"
                :label="item.engineeringName + '-' + item.shareProductCode" :value="item.engineeringId"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="认领金额（元）" align="center" width="220">
          <template slot-scope="scope">
            <el-input v-model="scope.row.claimMoney" type="text" style="width: 200px" clearable placeholder="请输入"
              @change="claimMoneyChange(scope.$index, scope.row)" />
          </template>
        </el-table-column>
        <el-table-column label="其他金额（元）" align="center" width="220">
          <template slot-scope="scope">
            <el-input v-model="scope.row.otherMoney" style="width: 200px" clearable placeholder="请输入"
              @change="otherMoneyChange(scope.$index, scope.row)" />
          </template>
        </el-table-column>
        <el-table-column label="单据号" align="center" width="220">
          <template slot-scope="scope">
            <el-input v-model="scope.row.shareDocumentNumber" style="width: 200px" clearable placeholder="请输入"
               />
          </template>
        </el-table-column>
        <el-table-column label="凭证号" align="center" width="220">
          <template slot-scope="scope">
            <el-input v-model="scope.row.voucherNumber" style="width: 200px" clearable placeholder="请输入"
               />
          </template>
        </el-table-column>
        <el-table-column label="流程" align="center" width="160">
          <template slot-scope="scope">
            <el-radio v-model="scope.row.flowPath" :label="1" style="margin-right: 0 !important">流程已走完</el-radio>
            <el-radio v-model="scope.row.flowPath" :label="0">流程未走完</el-radio>
          </template>
        </el-table-column>
        <el-table-column label="合同签订主体" align="center" width="300">
          <template slot-scope="scope">
            <span>{{ scope.row.collaborationUnit }}</span>
          </template>
        </el-table-column>
        <el-table-column label="合同单位" align="center" width="300">
          <template slot-scope="scope">
            <span>{{ scope.row.contractUnit }}</span>
          </template>
        </el-table-column>
        <el-table-column label="销售员" align="center" width="auto">
          <template slot-scope="scope">
            <!-- <el-input v-model="scope.row.saller" style="width: 300px" clearable placeholder="请输入" /> -->
            <span>{{ scope.row.saller }}</span>
          </template>
        </el-table-column>
        <el-table-column label="处别" align="center" width="auto">
          <template slot-scope="scope">
            <!-- <el-input v-model="scope.row.sallerDivision" style="width: 300px" clearable placeholder="请输入" /> -->
            <span>{{ scope.row.sallerDivision }}</span>
          </template>
        </el-table-column>
        <el-table-column label="财务编码" align="center" width="auto">
          <template slot-scope="scope">
            <!-- <el-input v-model="scope.row.financialCode" style="width: 300px" clearable placeholder="请输入" /> -->
            <span>{{ scope.row.financialCode }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="120" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" class="bottom_two" @click="delItem1(scope.$index)">
              <i class="icon iconfont" style="font-size: 12px"></i>
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialog4 = false">关 闭</el-button>
        <el-button type="primary" @click="addOtherSure">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
  
<script>
import mixin from "@/mixins/ICPSmixin.js";
import { formatTreeData } from "@/utils/utils";
// import { getDicsType } from "@/api/common.js";
// import { getUserInfo } from "@/utils/auth"
import {
  queryPage,
  queryPage1,
  queryPage2,
  Download,
  get_list_by_type,
  queryInvoicedAmount,
  saveOrUpdate,
  saveOrUpdatecollectMoney,
  deletePayUnit,
  get_detail_code,
  deleteNotes,
  queryEngineering,
  queryCollectClaimList,
  updateCollectMoneyClaim,
  queryDefaultSallers,
  sendMessionSaller,
  completeNotes,
  collectMoney,
  updateCollectMoneyFreeze,
} from "@/api/internetSales/projectPayment.js";
import { post } from "@/api/table.js";
import { getUserInfo } from "@/utils/auth.js";
export default {
  mixins: [mixin],
  data() {
    return {
      /*表格增删改查及下载接口*/
      queryPage: queryPage,
      queryPage1: queryPage1,
      DownloadURL: Download,
      batchUpdateOrDelete: deleteNotes,
      /*表格数据*/
      table: [
        { label: "收款编号", width: "120", prop: "id", status: true },
        { label: "票据状态", width: "120", prop: "billStatus", status: true },
        { label: "收款状态", width: "120", prop: "sureStatus", status: true },
        { label: "是否认领", width: "120", prop: "claimStatus", status: true },
        { label: "年月", width: "140", prop: "collectMoneyMouth", status: true },
        { label: "日期", width: "140", prop: "collectMoneyData", status: true },
        { label: "收款形式", width: "140", prop: "collectMoneyMethod", status: true },
        { label: "收款行及金融工具", width: "120", prop: "collectMoneyBank", status: true },
        { label: "付款单位", width: "300", prop: "payUnit", status: true },
        { label: "主体", width: "300", prop: "collaborativeAgent", status: true },
        { label: "收款（元）", width: "120", prop: "collectMoney", status: true },
        { label: "已认领（元）", width: "120", prop: "claimMoney", status: true },
        { label: "其他金额", width: "120", prop: "otherMoney", status: true },
        { label: "单据号", width: "120", prop: "shareDocumentNumber", status: true },
        { label: "凭证号", width: "120", prop: "voucherNumber", status: true },
        { label: "流程", width: "120", prop: "flowPath", status: true },
        { label: " 工程ID", width: "120", prop: "engineeringId", status: true },
        // { label: "合同单位", width: "300", prop: "collectMoney", status: true },
        { label: "工程名称", width: "300", prop: "enginnerrName", status: true },
        { label: "共享项目编码", width: "300", prop: "shareProductCode", status: true },
        { label: "合同签订主体", width: "300", prop: "collaborationUnit", status: true },
        { label: "合同单位", width: "300", prop: "contractUnit", status: true },
        { label: "财务编码", width: "120", prop: "financialCode", status: true },
        { label: "销售员", width: "120", prop: "saller", status: true },
        { label: "处别", width: "180", prop: "sallerDivision", status: true },
        { label: "集团内", width: "120", prop: "whetherGroup", status: true },
        { label: "票据类型", width: "120", prop: "billType", status: true },
        { label: "票号", width: "240", prop: "tiketNumber", status: true },
        { label: "承兑人名称", width: "240", prop: "acceptor", status: true },
        { label: "出票人户名", width: "240", prop: "drawerAccount", status: true },
        { label: "收款人户名", width: "240", prop: "payeeAccount", status: true },
        { label: "授信银行", width: "240", prop: "creditBank", status: true },
        { label: "背书人", width: "120", prop: "endorser", status: true },
        { label: "出票日期", width: "120", prop: "issueDate", status: true },
        { label: "到期日期", width: "120", prop: "dueDate", status: true },
        { label: "收取方式", width: "120", prop: "collectionMethod", status: true },
        { label: "合同、流程", width: "120", prop: "contractProcess", status: true },
        { label: "追索转让", width: "120", prop: "recourseTransfer", status: true },
        { label: "摘要", width: "300", prop: "excerpt", status: true },
        { label: "是否可融资", width: "240", prop: "remarkOne", status: true },
        { label: "备注2", width: "240", prop: "remarkTwo", status: true },
        { label: "备注3", width: "240", prop: "remarkThree", status: true },
        { label: "备注4", width: "240", prop: "remarkFour", status: true },
        { label: "操作", width: "240", prop: "", status: true },
      ],
      pagesType: 0,
      dialog: false,
      dialog1: false,
      dialog2: false,
      dialog3: false,
      dialog4: false,
      disabled: false,
      modifyType: false,
      low: {},
      rules: {
        collectMoneyData: [{ required: true, message: "请选择年月", trigger: "change" }],
        collectMoneyMouth: [{ required: true, message: "请选择日期", trigger: "change" }],
        collectMoneyMethodId: [{ required: true, message: "请选择收款形式", trigger: "change" }],
        collectMoneyBankId: [{ required: true, message: "请选择收款行及金融工具", trigger: "change" }],
        payUnitId: [{ required: true, message: "请选择付款单位", trigger: "change" }],
        collectMoney: [{ required: true, message: "请输入收款", trigger: "change" }],
        collaborativeAgentId: [{ required: true, message: "请选择主体", trigger: "change" }],
        // billTypeId: [{ required: true, message: "请选择票据类型", trigger: "change" }],
        // collectMoneyBankId: [{ required: true, message: "请选择收款行及金融工具", trigger: "change" }],
      },
      engineeringNameList: [], //工程名称列表
      invoicedAmount: "", //
      files: [],
      claimList: [
        { name: "流水待认领", id: 0 },
        { name: "流水未认领完", id: 1 },
        { name: "流水已认领，流程中", id: 2 },
        { name: "流水已认领", id: 3 },
        { name: "已完结", id: 4 },
      ], //是否认领列表
      mainList: [], //主体列表

      costMoneyInitData: [],
      payerUnitParams: {
        page: 1,
        pageSize: 10,
        payerUntiName: "",
      },
      totalpayerUnit: 0,
      tablepayerUnit: [],
      addPayerUnit: {
        payerUntiName: "",
        whetherGroup: 0,
      },
      payerUnitNoPage: [],
      formDate: {
        collectMoneyData: "",
        collectMoneyMouth: "",
        collectMoneyMethod: "",
        collectMoneyMethodId: "",
        collectMoneyBank: "",
        collectMoneyBankId: "",
        collectMoney: "",
        payUnitId: "",
        payUnit: "",
        whetherGroup: "",
        collaborativeAgent: "",
        collaborativeAgentId: "",
        billType: "",
        billTypeId: "",
        tiketNumber: "",
        acceptor: "",
        drawerAccount: "",
        payeeAccount: "",
        creditBank: "",
        endorser: "",
        issueDate: "",
        dueDate: "",
        recourseTransfer: "",
        recourseTransferId: "",
        contractProcess: "",
        contractProcessId: "",
        collectionMethod: "",
        collectionMethodId: "",
        remarkOne: "",
        remarkTwo: "",
        remarkThree: "",
        remarkFour: "",
      },
      shoukuanList: [],
      shoukuanandmonList: [],
      shoukuanandmonList1: [],
      shoukuanandmonList2: [],
      piaojuList: [],
      recourseTransferList: [
        { name: "无追可转", id: "1" },
        { name: "无追不可转", id: "2" },
        { name: "可追可转", id: "3" },
        { name: "可追不可转", id: "4" },
      ],
      contractProcessList: ["合同已收", "流程已收"],
      collectionMethodList: [
        { name: "合同约定", id: "1" },
        { name: "流程审核", id: "2" },
      ],
      editFlag: false,
      options: [],
      isMust: true,
      isMust2: true,
      isMust3: true,
      titleName: "添加",
      collectClaimList: [], //认领列表 
      mainListBodys: [], //
      renlingId: "",
      sallerList: [],
      treeArry: [],
      organizationList: [],
      userList: [],
      userNameList: [],
      sendFlag: true,
      loadingSaller: false,
      overheight: 400,
      startTimDateEndTimDate: [],
      UserInfo: "",
      selectRow: [],
      userData: [],
    };
  },
  watch: {
    startTimDateEndTimDate(val) {
      if (val?.length > 0) {
        this.tableParam.collectMoneyDataStart = val[0];
        this.tableParam.collectMoneyDataEnd = val[1];
      } else {
        this.tableParam.collectMoneyDataStart = "";
        this.tableParam.collectMoneyDataEnd = "";
      }
    },
  },
  async created() {
    this.UserInfo = await getUserInfo();
    /*存储拷贝的原初始化fromDate数据*/
    this.tableParam = {
      ...this.tableParam,
      claimStatus: "",
      collectMoneyData: "",
      enginnerrName: "",
      tiketNumber: "",
      collaborationUnit: "",
      saller: "",
      collectMoneyStart: "",
      collectMoneyEnd: "",
      collectMoneyMethodId: "",
      collectMoneyBankId: "",
      collectMoneyDataStart: "",
      collectMoneyDataEnd: "",
      financialCode: "",
    };
    this.gettableDataex();
    this.getpayerUnitManage();
    this.getpayerUnitNoPage();
    this.get_list_by_type();
    this.get_detail_code();
    this.queryEngineering();
    this.initOrganization();
    console.log("document.body.scrollWidth", document.body.scrollHeight);
    this.overheight = document.body.scrollHeight - 500;
  },
  mounted() {
    if (this.ButtonList.findIndex(res => res.buttonValue == "XIUGAI") == -1 && this.ButtonList.findIndex(res => res.buttonValue == "RENLING") == -1) {
      this.table[33].status = false;
    } else {
      this.table[33].status = true;
    }
  },
  methods: {
    //列表多选数据
    handleSelectionChange(val) {
      this.selectRow = [];
      this.selectRow = val;
      this.ids = [];
      this.sortIds = [];
      val.forEach(item => {
        this.ids.push(item.id);
        this.sortIds.push({
          id: item.id,
          sortNum: item.sortNum,
        });
      });
    },
    //默认月份
    setMonth(selectDate) {
      let date = new Date(selectDate).Format("yyyy-MM");
      this.formDate.collectMoneyMouth = date;
    },
    handleCopyClick() {
      if (this.selectRow.length !== 1) {
        this.$message({
          message: "请先勾选一条需要复制的数据",
          type: "warning",
        });
        return;
      }
      // 直接调用改造后的 lookcard，传入当前勾选的行数据，并将 isCopy 标记设为 true
      this.lookcard(this.selectRow[0], true);
    },
    //冻结解冻
    changeFreeze(status, text) {
      if (this.ids.length == 0) {
        this.$message({
          message: "请选择要操作的数据项",
          type: "warning",
        });
        return;
      }
      this.$confirm(`此操作将永久${text}该信息?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "bottom_all_two",
        confirmButtonClass: "bottom_all",
        type: "warning",
      })
        .then(() => {
          updateCollectMoneyFreeze({ list: this.ids, status: status }).then(res => {
            if (res.code == 1001) {
              this.gettableDataex();
              this.$message({
                message: `${text}成功`,
                type: "success",
              });
            }
          });
        })
        .catch(() => { });
    },
    collectMoneyChange(e) {
      console.log(e);
      this.formDate.collectMoney = this.numFormat(e || 0);
      console.log(this.formDate.collectMoney);
    },
    claimMoneyChange(i, v) {
      console.log(i);
      console.log(v);
      v.claimMoney = this.numFormat(v.claimMoney || 0);
      this.$set(this.collectClaimList, i, this.collectClaimList[i]);
    },
    otherMoneyChange(i, v) {
      console.log(i);
      console.log(v);
      v.otherMoney = this.numFormat(v.otherMoney || 0);
      this.$set(this.collectClaimList, i, this.collectClaimList[i]);
      console.log("-------------------------------------")
      console.log(this.collectClaimList)
    },
    numFormat(num) {
      var res = num.toString().replace(/\d+/, function (n) {
        // 先提取整数部分
        return n.replace(/(\d)(?=(\d{3})+$)/g, function ($1) {
          return $1 + ",";
        });
      });
      return res;
    },
    commafybackTY(num) {
      var x = num.split(",");
      return parseFloat(x.join(""));
    },
    structuralPartsCheckFun() {
      // this.formDate.contractProcess = "";
      let item = this.contractProcessList.find(v => v.id == this.formDate.contractProcess);
      console.log(item);
      // if (item) {
      //     this.formDate.strengthGradeId = JSON.parse(item.strengthGrade)[0].id;
      //     if (item.performanceGrade) {
      //         this.formDate.performanceGradeIdList = JSON.parse(item.performanceGrade).map(v => v.id);
      //     }
      //     if (item.meterialRequirements) {
      //         this.formDate.meterialRequirementsIdList = JSON.parse(item.meterialRequirements).map(v => v.id);
      //     }
      //     if (item.specialRequirements) {
      //         this.formDate.specialRequirementsIdList = JSON.parse(item.specialRequirements).map(v => v.id);
      //     }
      //     if (item.otherRequirements) {
      //         this.formDate.otherRequirementsIdList = JSON.parse(item.otherRequirements).map(v => v.id);
      //     }
      //     if (item.admixtureRequirements) {
      //         this.formDate.admixtureRequirementsIdList = JSON.parse(item.admixtureRequirements).map(v => v.id);
      //     }
      // }
    },
    /**
     * @Description: 获取所有组织和用户、格式化tree结构
     * @Param:
     * @Author: wangwangwang
     */
    initOrganization() {
      /* 
              把计算缓慢的数据暂时隐藏
            */
      // const { state } = this.$store;
      // if (!state.approvePerson.orgList || !state.approvePerson.userList) {
      //   console.log("---------user----------");
      //   const orgPromise = this.$store.dispatch("approvePerson/getorg");
      //   const userPromise = this.$store.dispatch("approvePerson/getuser");
      //   this.loading = true;
      //   Promise.all([orgPromise, userPromise])
      //     .then(([orgres, userres]) => {
      //       this.formatDataSource(orgres, userres);
      //     })
      //     .catch(e => console.log(e));
      // } else {
      //   this.formatDataSource(state.approvePerson.orgList, state.approvePerson.userList);
      // }
      //注释组织树
      // const orgPromise = localStorage.getItem("setPersonOrg") ? JSON.parse(localStorage.getItem("setPersonOrg")) : this.$store.dispatch("approvePerson/getorg");
      // const userPromise = localStorage.getItem("setPersonUser") ? JSON.parse(localStorage.getItem("setPersonUser")) : this.$store.dispatch("approvePerson/getuser");
      // this.loading = true;
      // Promise.all([orgPromise, userPromise])
      //   .then(([orgres, userres]) => {
      //     console.log("orgres", orgres);
      //     console.log("userres", userres);
      //     this.formatDataSource(orgres, userres);
      //   })
      //   .catch(e => console.log(e));
      this.userData = localStorage.getItem("setPersonUser") ? JSON.parse(localStorage.getItem("setPersonUser")) : this.$store.dispatch("approvePerson/getuser");
      console.log(this.userData)
    },
    formatDataSource(orgList, userList) {
      orgList.forEach(v => {
        v.type = 2;
      });
      this.organizationList = formatTreeData(orgList, "id", "parentId", "children", "parent_id");
      if (!userList) {
        userList = [];
      }
      userList.forEach(v => {
        v.type = 1;
      });
      const newArry = userList.map(item => ({
        ...item,
        parentId: item.organizationId,
      }));
      this.userList = userList;
      /* 
              把计算缓慢的数据暂时隐藏
            */
      let storageUserList = []; //缓存的用户数据
      this.$forage.getItem("orgListData").then(val => {
        storageUserList = val;
      });
      console.log(storageUserList);
      if (storageUserList?.length > 0) {
        this.allData = storageUserList;
        this.treeArry = storageUserList;
        console.log("this.treeArry", this.treeArry);
      } else {
        let arr = formatTreeData(orgList.concat(newArry), "id", "parentId", "children", "parent_id");
        this.allData = arr;
        this.treeArry = arr;
        this.$forage.setItem("orgListData", arr).then(val => {
          console.log(val);
        });
        console.log("this.treeArry", this.treeArry);
      }
      // this.treeArry = formatTreeData(
      //   orgList.concat(newArry),
      //   "id",
      //   "parentId",
      //   "children",
      //   "parent_id"
      // );
      // this.allData = formatTreeData(
      //   orgList.concat(newArry),
      //   "id",
      //   "parentId",
      //   "children",
      //   "parent_id"
      // );
      this.loading = false;
    },
    delItem(i) {
      this.sallerList.splice(i, 1);
      console.log(this.sallerList);
    },
    delItem1(i) {
      console.log(i);
      this.collectClaimList.splice(i, 1);
    },
    addsallerList() {
      let arr = this.$refs["cascader"].getCheckedNodes();
      arr.forEach(e => {
        if (e.children.length == 0) {
          this.sallerList.push({ saller: e.label, sallerId: e.value });
        }
      });
      const map = new Map();
      const newList3 = this.sallerList.filter(v => !map.has(v.sallerId) && map.set(v.sallerId, 1));
      this.sallerList = newList3;
    },
    sendSrueSaller() {
      let ids = [];
      this.sallerList.forEach(e => {
        ids.push(e.sallerId);
      });
      if (this.sendFlag) {
        this.sendFlag = false;
        sendMessionSaller(ids).then(res => {
          if (res.code == 1001) {
            this.$message.success("操作成功！");
            this.dialog3 = false;
          }
        });
        setTimeout(() => {
          this.sendFlag = true;
        }, 500);
      }
    },
    userChooseChange() {
      // console.log(e);
    },
    setTitle(row) {
      console.log(row);
      const columnIndex = row.columnIndex;
      if (columnIndex == 10 || columnIndex == 11 || columnIndex == 12 || columnIndex == 13 || columnIndex == 14 || columnIndex == 15 || columnIndex == 16 || columnIndex == 17) {
        return "background: #fffd97;";
      } else {
        return "background: #f3f6f9;";
      }
    },
    getCollectMoneyMethod(id) {
      var arrChoose = this.shoukuanList.filter(e => {
        if (e.id == id) {
          return true;
        }
      });
      if (arrChoose[0].itemName == "供应链金融产品") {
        this.shoukuanandmonList = JSON.parse(JSON.stringify(this.shoukuanandmonList2));
        this.tableParam.collectMoneyBankId = "";
      } else {
        this.shoukuanandmonList = JSON.parse(JSON.stringify(this.shoukuanandmonList1));
        this.tableParam.collectMoneyBankId = "";
      }
    },
    changestatus(id) {
      console.log(id);
      var arrChoose = this.shoukuanList.filter(e => {
        if (e.id == id) {
          return true;
        }
      });
      this.$nextTick(() => {
        if (arrChoose[0].itemName == "银行存款" || arrChoose[0].itemName == "内转") {
          this.isMust = false;
          this.isMust3 = false;
          this.isMust2 = true;
          this.formDate.acceptor = "";
          this.formDate.drawerAccount = "";
          this.formDate.endorser = "";
          this.$refs["formDate"].clearValidate();
        } else if (arrChoose[0].itemName == "抵款" || arrChoose[0].itemName == "其他" || arrChoose[0].itemName == "债务重组") {
          this.isMust = false;
          this.isMust2 = false;
          this.isMust3 = false;
          this.formDate.acceptor = "";
          this.formDate.drawerAccount = "";
          this.formDate.endorser = "";
          this.$refs["formDate"].clearValidate();
        } else if (arrChoose[0].itemName == "银行承兑" || arrChoose[0].itemName == "商业承兑") {
          this.isMust = true;
          this.isMust2 = true;
          this.isMust3 = false;
        } else {
          this.isMust = true;
          this.isMust2 = true;
          this.isMust3 = true;
        }
        if (arrChoose[0].itemName == "供应链金融产品") {
          this.shoukuanandmonList = JSON.parse(JSON.stringify(this.shoukuanandmonList2));
          this.formDate.collectMoneyBankId = "";
        } else {
          this.shoukuanandmonList = JSON.parse(JSON.stringify(this.shoukuanandmonList1));
          this.formDate.collectMoneyBankId = "";
        }
        if (arrChoose[0].itemName == "银行承兑" || arrChoose[0].itemName == "商业承兑") {
          this.piaojuList.forEach(e => {
            if (e.itemName == arrChoose[0].itemName) {
              this.formDate.billTypeId = e.id;
            }
          });
        }
      });
    },
    initaddPayer() {
      this.addPayerUnit = this.$options.data().addPayerUnit;
    },
    addPayerUnitSure() {
      saveOrUpdate(this.addPayerUnit).then(res => {
        if (res.code == 1001) {
          this.$message({
            message: "添加成功",
            type: "success",
          });
          this.getpayerUnitManage();
          this.initaddPayer();
          this.dialog2 = false;
        }
      });
    },
    delPayerUnit(row) {
      this.$confirm("此操作将永久删除该信息?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "bottom_all_two",
        confirmButtonClass: "bottom_all",
        type: "warning",
      })
        .then(() => {
          deletePayUnit({ id: row.id }).then(res => {
            if (res.code == 1001) {
              this.getpayerUnitManage();
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
          });
        })
        .catch(() => { });
    },
    /*获取付款单位不分页列表 */
    getpayerUnitNoPage(payerUntiName) {
      queryPage2({ payerUntiName }).then(res => {
        if (res.code == 1001) {
          this.payerUnitNoPage = res.data;
        }
      });
    },
    /*获取列表*/
    async gettableDataex() {
      this.tableLoading = true;
      await post(this.queryPage, this.tableParam).then(res => {
        if (res.code === 1001) {
          this.tableLoading = false;
          this.total = res.data.totalRows;
          this.tableData = res.data.data;
          this.reChange();
          this.copyDataSource = JSON.parse(JSON.stringify(res.data.data));
        }
      });
    },
    /*获取付款单位列表*/
    async getpayerUnitManage() {
      this.tableLoading = true;
      await post(this.queryPage1, this.payerUnitParams).then(res => {
        if (res.code === 1001) {
          this.tableLoading = false;
          this.totalpayerUnit = res.data.totalRows;
          this.tablepayerUnit = res.data.data;
        }
      });
    },
    /* 获取主体 */
    get_list_by_type() {
      get_list_by_type({ typeId: "19da56b9e85648059e3cf1e7da497da4" }).then(res => {
        if (res.code == 1001) {
          this.mainList = res.data;
        }
      });
    },
    /* 获取字典 */
    get_detail_code() {
      //
      get_detail_code({ codes: "SHOUKUANXINGSHI,SHOUKUANHANG1,SHOUKUANHANG4,PIAOJULEIXING,engineeringMainBody" }).then(res => {
        if (res.code == 1001) {
          console.log(res.data);
          this.shoukuanList = res.data["SHOUKUANXINGSHI"].items;
          this.shoukuanandmonList1 = res.data["SHOUKUANHANG1"].items;
          this.shoukuanandmonList = res.data["SHOUKUANHANG1"].items;
          this.shoukuanandmonList2 = res.data["SHOUKUANHANG4"].items;
          this.piaojuList = res.data["PIAOJULEIXING"].items;
          this.mainListBodys = res.data["engineeringMainBody"].items;
        }
      });
    },
    reChange() {
      let arr = [];
      this.tableData.forEach(e => {
        if (e.collectMoney) {
          e.collectMoney = this.numFormat(e.collectMoney || 0);
        }

        if (e.collectMoneyClaimList.length > 0) {
          let length = e.collectMoneyClaimList.length;
          e.collectMoneyClaimList.forEach((m, n) => {
            m.whetherGroup = e.whetherGroup
            if (m.claimMoney) {
              m.claimMoney = this.numFormat(m.claimMoney || 0);
            }
            m.id = e.id;
            if (n === 0) {
              arr.push({ ...e, ...m, rowspan: length, colspan: 1 });
            } else {
              arr.push({ ...e, ...m, rowspan: 0, colspan: 0 });
            }
          });
        } else {
          arr.push({ ...e, rowspan: 1, colspan: 1 });
        }
      });
      this.tableData = arr;
      this.$refs.table.doLayout()
    },
    changePayUnit() {
      var arrChoose = this.payerUnitNoPage.filter(e => {
        if (e.id == this.formDate.payUnitId) {
          return true;
        }
      });
      this.formDate.whetherGroup = arrChoose[0].whetherGroup;
      if (!this.isMust) {
        //
      } else {
        this.formDate.acceptor = arrChoose[0].payerUntiName;
        this.formDate.drawerAccount = arrChoose[0].payerUntiName;
        this.formDate.endorser = arrChoose[0].payerUntiName;
      }
    },
    changeCollaborat() {
      var arrChoose = this.mainListBodys.filter(e => {
        if (e.id == this.formDate.collaborativeAgentId) {
          return true;
        }
      });
      console.log(arrChoose);
      this.formDate.collaborativeAgent = arrChoose[0].itemName;
    },
    changePayeeAccount() {
      var arrChoose = this.mainList.filter(e => {
        if (e.name == this.formDate.payeeAccount) {
          return true;
        }
      });
      this.formDate.payeeAccountId = arrChoose[0].id || "";
    },
    addcardSure(formName) {
      console.log(this.formDate);
      // if(!this.editFlag){
      //     return;
      // }
      // let data = { ...this.low, invoiceAssembleAmount: this.invoicedAmount };
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.formDate.collectMoneyClaimList) {
            console.log(this.formDate.collectMoneyClaimList)
            this.formDate.collectMoneyClaimList.forEach(e => {
              e.claimMoney = this.commafybackTY(e.claimMoney);
            });
          }
          if (this.formDate.claimMoney) {
            this.formDate.claimMoney = this.commafybackTY(this.formDate.claimMoney);
          }
          this.formDate.collectMoney = this.commafybackTY(this.formDate.collectMoney);
          console.log(this.formDate);
          saveOrUpdatecollectMoney(this.formDate).then(res => {
            if (res.code == 1001) {
              this.$message({
                message: "添加成功",
                type: "success",
              });
              this.gettableDataex();
              this.dialog = false;
            }
            
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    queryEngineering() {
      queryEngineering({ isMainEngineering: 1 }).then(res => {
        this.engineeringNameList = res.data;
      });
    },
    queryInvoicedAmount(id) {
      queryInvoicedAmount({ engId: id }).then(res => {
        this.invoicedAmount = res.data;
      });
    },
    /**
     * @Description: 删除附件
     * @Param:
     * @Author: wangwangwang
     */
    deleteFile(index) {
      this.files.splice(index, 1);
    },
    /**
     * @Description: 上传成功
     * @Param:
     * @Author: wangwangwang
     */
    uplodeSuccess(data) {
      this.files.push(data);
    },
    addCollectClaim() {
      let item = {
        engineeringId: "", //工程id
        enginnerrName: "", //工程名
        claimMoney: 0, //认领金额
        flowPath: 1, //流程：0流程未走完；1流程已走完
        collaborationUnit: "", //合同签订主体d
        collaborationUnitId: "", //合同签订主体
        financialCode: "", //财务编码
        saller: "", //销售员
        sallerId: "", //销售员id
        sallerDivision: "", //销售处别
        sallerDivisionId: "", //销售处别id
        shareDocumentNumber:"", //共享单据号
        voucherNumber:"", //凭证号
        otherMoney: 0,
      };
      this.collectClaimList.push(item);
    },
    addOtherCard(row) {
      console.log(row);
      this.formDate = row;
      this.renlingId = row.id;
      queryCollectClaimList({ id: row.id }).then(res => {
        if (res.code == 1001) {
          res.data.forEach(e => {
            e.claimMoney = this.numFormat(e.claimMoney || 0);
          });
          this.collectClaimList = res.data;
        }
      });
      this.dialog4 = true;
    },
    addcard() {
      this.formDate = this.$options.data().formDate;
      this.titleName = "添加";
      this.dialog = true;
      this.$nextTick(() => {
        this.$refs["formDate"].clearValidate();
      });
    },
    costMoneyInit() {
      this.dialog1 = true;
    },
    tableRowClassName({ row }) {
      if (row.sureStatus == 1) {
        return "success-row";
      }
    },
    receiveConfirm() {
      if (this.ids.length == 0) {
        this.$message({
          message: "请选择要操作的数据项",
          type: "warning",
        });
        return;
      }
      for (var i = 0; i < this.selectRow.length; i++) {
        if (this.selectRow[i].sallerId != this.UserInfo.userId) {
          this.$message.warning(`收款编码为${this.selectRow[i].collectMoneyId}的销售员${this.selectRow[i].saller}与当前登录账号不一致，请确认!`)
          return
        }
        if (this.selectRow[i].flowPath == 0) {
          this.$message.warning(`收款编码为${this.selectRow[i].collectMoneyId}的流程未走完请确认!`)
          return
        }
      }
      this.$confirm("此操作将该信息进行收款确认操作?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "bottom_all_two",
        confirmButtonClass: "bottom_all",
        type: "warning",
      })
        .then(() => {
          collectMoney(this.ids).then(res => {
            if (res.code == 1001) {
              let page = Math.ceil((this.total - this.ids.length) / this.tableParam.pageSize);
              if (this.tableParam.page > Math.ceil(page / this.tableParam.pageSize)) {
                this.tableParam.page = page;
              }
              this.gettableDataex();
              this.$message({
                message: "确认成功",
                type: "success",
              });
            }
          });
        })
        .catch(() => { });
    },
    sallerSure() {
      // this.loadingSaller = true
      queryDefaultSallers().then(res => {
        if (res.code == 1001) {
          this.sallerList = res.data;
        }
      });
      setTimeout(() => {
        this.dialog3 = true;
        this.loadingSaller = false;
      });
    },
    lookcard(row, isCopy = false) {
      // 1. 根据操作类型动态设置标题
      this.titleName = isCopy ? "添加" : "修改";
      console.log(row);
      this.formDate = this.copy(row);
      // 2. 如果是复制操作，把所有数据的 ID 置空，
      if (isCopy) {
          this.formDate.id = null;
          this.formDate.collectMoneyId = null; 
          // 1. 重置所有状态为初始状态 (0)
          this.formDate.claimStatus = 0; // 重置为未认领
          this.formDate.sureStatus = 0;  // 重置为未确认
          this.formDate.billStatus = 0;  // 重置为普通票据 (根据你的枚举)
          this.formDate.flowPath = 0;    // 流程未走完
          // 2. 清空各种后续才会产生的金额和明细
          this.formDate.claimMoney = 0;  // 已认领金额清零
          this.formDate.otherMoney = 0;  // 其他金额清零
          // 3. 直接把认领明细的数组清空
          this.formDate.collectMoneyClaimList = []; 
      }
      if (row.collectMoneyMethod == "供应链金融产品") {
        this.shoukuanandmonList = this.copy(this.shoukuanandmonList2);
      } else {
        this.shoukuanandmonList = this.copy(this.shoukuanandmonList1);
      }
      this.dialog = true;
      this.$nextTick(() => {
        if (row.collectMoneyMethod == "银行存款") {
          this.isMust = false;
          this.isMust3 = false;
          this.isMust2 = true;
          this.$refs["formDate"].clearValidate();
        } else if (row.collectMoneyMethod == "抵款" || row.collectMoneyMethod == "其他") {
          this.isMust = false;
          this.isMust2 = false;
          this.isMust3 = false;
          this.$refs["formDate"].clearValidate();
        } else if (row.collectMoneyMethod == "银行承兑" || row.collectMoneyMethod == "商业承兑") {
          this.isMust = true;
          this.isMust2 = true;
          this.isMust3 = false;
          this.$refs["formDate"].clearValidate();
        } else {
          this.isMust = true;
          this.isMust2 = true;
          this.isMust3 = true;
          this.$refs["formDate"].clearValidate();
        }
      });
    },
    delHandler() {
      if (this.ids.length == 0) {
        this.$message({
          message: "请选择要操作的数据项",
          type: "warning",
        });
        return;
      }
      this.$confirm("此操作将永久删除该信息?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "bottom_all_two",
        confirmButtonClass: "bottom_all",
        type: "warning",
      })
        .then(() => {
          post(this.batchUpdateOrDelete, this.ids).then(res => {
            if (res.code == 1001) {
              let page = Math.ceil((this.total - this.ids.length) / this.tableParam.pageSize);
              if (this.tableParam.page > Math.ceil(page / this.tableParam.pageSize)) {
                this.tableParam.page = page;
              }
              this.gettableDataex();
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
          });
        })
        .catch(() => { });
    },
    complete() {
      if (this.ids.length == 0) {
        this.$message({
          message: "请选择要操作的数据项",
          type: "warning",
        });
        return;
      }
      this.$confirm("此操作将修改该信息为已完结状态?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "bottom_all_two",
        confirmButtonClass: "bottom_all",
        type: "warning",
      })
        .then(() => {
          completeNotes(this.ids).then(res => {
            if (res.code == 1001) {
              let page = Math.ceil((this.total - this.ids.length) / this.tableParam.pageSize);
              if (this.tableParam.page > Math.ceil(page / this.tableParam.pageSize)) {
                this.tableParam.page = page;
              }
              this.gettableDataex();
              this.$message({
                message: "修改成功",
                type: "success",
              });
            }
          });
        })
        .catch(() => { });
    },
    changstatus(e, row) {
      var chooseArr = this.engineeringNameList.filter(m => {
        if (m.engineeringId == row.engineeringId) {
          return true;
        }
      });

      // this.collectClaimList[e].saller = chooseArr[0].saller
      // this.collectClaimList[e].sallerDivision = chooseArr[0].sallerDivision
      this.collectClaimList[e] = { ...this.collectClaimList[e], ...chooseArr[0] };
      this.collectClaimList[e].enginnerrName = chooseArr[0].engineeringName;
      if (!chooseArr[0].financialCode) {
        this.collectClaimList[e].financialCode = "";
      } else {
        this.collectClaimList[e].financialCode = chooseArr[0].financialCode;
      }
      if (!chooseArr[0].collaborationUnit) {
        this.collectClaimList[e].collaborationUnit = "";
      } else {
        this.collectClaimList[e].collaborationUnit = chooseArr[0].collaborationUnit;
      }
      this.$set(this.collectClaimList, e, this.collectClaimList[e]);
    },
    addOtherSure() {
      console.log(this.collectClaimList);
      this.collectClaimList.forEach(e => {
        e.claimMoney = this.commafybackTY(e.claimMoney.toString());
        if (e.otherMoney) {
          // e.otherMoney =  e.otherMoney*1;
          e.otherMoney = this.commafybackTY(e.otherMoney);
        }
      });
      console.log(this.collectClaimList);
      let data = {
        id: this.renlingId,
        collectMoneyClaimList: this.collectClaimList,
      };
      updateCollectMoneyClaim(data).then(res => {
        if (res.code == 1001) {
          this.gettableDataex();
          this.$message({
            message: "操作成功",
            type: "success",
          });
          this.dialog4 = false;
        }
      });
    },
    chooseNav(index) {
      this.currenindex = index;
    },
    open(low, key, disabled) {
      this.low = this.copy(low);
      this.disabled = disabled;
      this[key] = true;
    },
    reset(key) {
      this[key] = false;
    },
    submit(key) {
      this[key] = false;
      this.gettableDataex();
    },
    /*重置数据,此方法必须存在，并且方发只重置条件*/
    init() {
      this.tableParam = {
        ...this.tableParam,
        claimStatus: "",
        collectMoneyData: "",
        enginnerrName: "",
        tiketNumber: "",
        collaborationUnit: "",
        saller: "",
        collectMoneyStart: "",
        collectMoneyEnd: "",
        collectMoneyMethodId: "",
        collectMoneyBankId: "",
        collectMoneyDataStart: "",
        collectMoneyDataEnd: "",
        financialCode: "",
      };
      this.startTimDateEndTimDate = [];
      this.gettableDataex();
    },
    sizeChange(value) {
      this.tableParam.pageSize = value;
      this.gettableDataex();
    },
    objectSpanMethod({ row, columnIndex }) {
      // console.log(column)
      // console.log(rowIndex)
      if (row.rowspan > 1) {
        if (columnIndex !== 10 && columnIndex !== 11 && columnIndex !== 12 && columnIndex !== 13 && columnIndex !== 14 && columnIndex !== 15 && columnIndex !== 16 && columnIndex !== 17 && columnIndex !== 18 && columnIndex !== 19 && columnIndex !== 22 && columnIndex !== 25) {
          return {
            rowspan: row.rowspan,
            colspan: row.colspan,
          };
        }
      } else {
        if (columnIndex !== 10 && columnIndex !== 11 && columnIndex !== 12 && columnIndex !== 13 && columnIndex !== 14 && columnIndex !== 15 && columnIndex !== 16 && columnIndex !== 17 && columnIndex !== 18 && columnIndex !== 19 && columnIndex !== 22 && columnIndex !== 25) {
          return {
            rowspan: row.rowspan,
            colspan: row.colspan,
          };
        }
      }
    },
  },
};
</script>
  
<style lang="scss" scoped>
.el-input,
.el-select {
  width: 240px;
}

.tabtop {
  width: 381px;
}

.bill_title {
  font-size: 18px;
  font-weight: 600;
  padding: 15px 0;
}

.el-select-dropdown__list {
  width: 400px;
}

.boxSaller {
  display: flex;
  flex-wrap: wrap;
}

.sallerItem {
  // width: auto;
  height: 30px;
  background: #c4f0d9;
  // color: #fff;
  text-align: center;
  line-height: 30px;
  align-items: center;
  margin-right: 10px;
  margin-bottom: 10px;
  padding: 0 10px;
}

.search {
  display: flex;
  flex-wrap: wrap;
}
</style>
<style lang="scss">
.success-row {
  background: #b6b6b6 !important;
}
</style>

  